import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    currentTypeItems: [] as string[], // Array of UUIDs in display order
    currentType: null as string | null,
  }),

  actions: {
    setCurrentTypeItems(items: string[]) {
      this.currentTypeItems = items
    },
    setCurrentType(type: string) {
      this.currentType = type
    },
  },

  getters: {
    getNextItem: (state) => (currentUuid: string) => {
      const currentIndex = state.currentTypeItems.indexOf(currentUuid)
      return currentIndex < state.currentTypeItems.length - 1
        ? state.currentTypeItems[currentIndex + 1]
        : null
    },
    getPreviousItem: (state) => (currentUuid: string) => {
      const currentIndex = state.currentTypeItems.indexOf(currentUuid)
      return currentIndex > 0 ? state.currentTypeItems[currentIndex - 1] : null
    },
  },
})
